import { render, staticRenderFns } from "./roleForm.vue?vue&type=template&id=4f672750&"
import script from "./roleForm.vue?vue&type=script&lang=ts&"
export * from "./roleForm.vue?vue&type=script&lang=ts&"
import style0 from "./roleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports